import useLiveDay from "../atoms/useLiveDay";
import { OrdersLive } from "../v2/queries/interfacesV2";

const useLiveDayOrders = (data: OrdersLive) => {
  const [day] = useLiveDay();
  return data && data[day] ? data[day] : [];
};

export default useLiveDayOrders;
